<template>
  <div class="available-hotels">
    <p class="title">{{ $t('Available Hotels') }}</p>
    <ul v-loading="!hotelTables.length">
      <li v-for="(hotel,index) of hotelTables" :key="index">
        <div class="hotel-img" @click="showGallery(hotel.images,hotel.name,hotel.des)">
          <img v-if="hotel.images.find(element => element.is_main)"
               :src="hotel.images.find(element => element.is_main).url" :alt="hotel.name">
          <span class="gallery-icon"
                v-if="hotel.images.find(element => element.is_main)">
            {{ $t('Gallery') }}
          </span>
        </div>
        <div class="hotel-detail">
          <p class="hotel-title" @click="toggle">{{ hotel.name }}</p>
          <div class="describe-box" :no-style="{height:boxHeight[index]+'px'}">
            <div class="hotel-describe cms-style" v-html="hotel.des" :ref="'box'+index"/>
          </div>
          <div class="hotel-trait" v-if="0">
            <p>{{ $t('Premium Suite') }}</p>
            <ul>
              <li v-for="(suite,index) of hotel.premium_suite" :key="index">{{ suite }}</li>
            </ul>
          </div>
          <div class="hotel-action">
            <button class="primary">{{ $t('VIEW RATES') }}</button>
            <div class="price-box">
              From lowest <span>830 HKD**</span> per night copy
            </div>
          </div>
        </div>
      </li>
    </ul>
    <p class="tips" v-if="0">** {{ $t('Display currencies are for reference only') }}.
      {{ $t('Price subject to change based on dates and hotel selections') }}.</p>
    <silk-popup :show="gallery" @popup-close="gallery=false" class="img-popup">
      <img-view :images="gallery" :text="galleryText" :content="galleryContent" v-if="gallery"/>
    </silk-popup>

  </div>
</template>

<script>
import {mapState} from 'vuex'
import ImgView from '@/components/ImgView.vue'


export default {
  data() {
    return {
      gallery: '',
      galleryText: '',
      galleryContent: '',
      hotelTables: '',
      boxHeight: []
    };
  },
  components: {
    ImgView
  },
  created() {
    this.getHotelTable()
  },
  methods: {
    showGallery(img, galleryText, galleryContent) {
      this.gallery = img.map((x) => x.url)
      this.galleryText = galleryText
      this.galleryContent = galleryContent
    },
    toggle(event) {
      if (!event.target.classList.contains('active')) {
        event.target.classList.add("active")
      } else {
        event.target.classList.remove("active")
      }
    },
    getHotelTable() {
      this.axios.get('/api/employee/info/hotels').then(
        (res) => {
          if (res.code === 200) {
            this.hotelTables = res.data.hotels;
          }
        }
      )
    },
  },
  computed: {
    ...mapState([])
  },
  watch: {
    hotelTables(arr) {
      this.$nextTick(() => {
        for (let n = 0; n < arr.length; n++) {
          this.boxHeight.push(
            this.$refs['box' + n][0].offsetHeight
          )
        }
      })
    }
  }
}
</script>
